import { Ability } from '@casl/ability'
import { initialAbility } from './config'

const ability = new Ability(initialAbility);
export default ability





